export default __webpack_public_path__ + "static/media/empty_partner.ed88afdd.svg";